var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmbitionMountainsBw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 422 436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B8B8B8",
    d: "M131.07 173.4c-12.52-5.62-12.6-23.37-.14-29.12L444 0v314L131.07 173.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8A8A8",
    d: "M32.08 275.98c-12.52-5.62-12.61-23.38-.14-29.12L444 57v404L32.08 275.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7D7D7D",
    d: "M161.59 187.12 444 57v257L161.59 187.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    d: "M153.07 397.28c-12.53-5.63-12.61-23.38-.14-29.12L444 234v294L153.07 397.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D9D9D",
    d: "M194.57 348.96 444 234v227L194.57 348.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    d: "M444 234v80l-87.9-39.49L444 234Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbitionMountainsBw);
export default __webpack_public_path__ + "static/media/ambition-mountains-bw.7c99bdcbfc796ee77c7944271b84b767.svg";
export { ForwardRef as ReactComponent };